import { render } from "./index.vue?vue&type=template&id=7bcf2ff0&scoped=true&bindings={}"
import script from "./ShowcaseItem.js?vue&type=script&lang=js"
export * from "./ShowcaseItem.js?vue&type=script&lang=js"

import "./ShowcaseItem.scss?vue&type=style&index=0&id=7bcf2ff0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7bcf2ff0"

export default script